 
const ConsignmentActions = (props) => {
    const handleRouteClick = (e) => {
        e.stopPropagation();
        // console.log("MAP Icon ", props)
        // props.context.componentParent.onCloseUploadDiv(e);
        // props.context.componentParent.onCloseRouteDiv(e);
        props.context.onShowTransitData(props);
    };

    return (
            <a onClick={handleRouteClick}  title="Transit Delay"><i className="icofont icofont-clock-time f20"></i> </a>
        
    );
};

export default ConsignmentActions;
